import mobWebp from '../../images/blog/mobile/blog.webp';
import mobWebp2x from '../../images/blog/mobile/blog@2x.webp';
import mobJpeg from '../../images/blog/mobile/blog.jpg';
import mobJpeg2x from '../../images/blog/mobile/blog@2x.jpg';

import tabletWebp from '../../images/blog/tablet/blog.webp';
import tabletWebp2x from '../../images/blog/tablet/blog@2x.webp';
import tabletJpeg from '../../images/blog/tablet/blog.jpg';
import tabletJpeg2x from '../../images/blog/tablet/blog@2x.jpg';

import deskWebp from '../../images/blog/desktop/blog.webp';
import deskWebp2x from '../../images/blog/desktop/blog@2x.webp';
import deskJpeg from '../../images/blog/desktop/blog.jpg';
import deskJpeg2x from '../../images/blog/desktop/blog@2x.jpg';

export const images = {
  mobWebp,
  mobWebp2x,
  mobJpeg,
  mobJpeg2x,
  tabletWebp,
  tabletWebp2x,
  tabletJpeg,
  tabletJpeg2x,
  deskWebp,
  deskWebp2x,
  deskJpeg,
  deskJpeg2x,
};
